import styled from 'styled-components';

import { colors } from 'styles/colors';

const positiveBg = '#DCE9F8';
const negativeBg = colors.bg['danger-light-0'];
const textSub = colors.text['sub-500'];

export const CardContainer = styled.div`
  padding: 24px;
  border-radius: 16px;
  background-color: ${colors.White};
  box-shadow: 0 3px 8px rgba(0,0,0,0.24), 0 3px 12px rgba(0,0,0,0.12);
`;

export const ResultWrap = styled.div`
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 16px;
`;

export const ResultIconWrap = styled.div<{ $variant: 'positive' | 'negative' | 'off' }>`
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: ${({ $variant }) => {
    if ($variant === 'negative') return negativeBg;
    if ($variant === 'off') return colors.Grey030;
    return positiveBg;
  }};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const ResultBody = styled.div`
  flex: 1;
  min-width: 220px;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const ResultTitle = styled.div<{ $variant?: 'positive' | 'negative' | 'off' }>`
  font-size: 14px;
  font-weight: 700;
  color: ${({ $variant }) => {
    if ($variant === 'negative') return colors.Red;
    if ($variant === 'off') return colors.Grey300;
    return colors.LightBlue;
  }};
`;

export const ResultDesc = styled.div`
  font-size: 12px;
  color: ${textSub};
  line-height: 1.55;
  max-width: 600px;
`;

export const ResultMeta = styled.div`
  font-size: 11px;
  color: ${colors.Grey300};
`;

export const StatusBadge = styled.span<{ $variant: 'positive' | 'negative' | 'in_progress' }>`
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  gap: 5px;
  padding: 3px 9px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  background: ${({ $variant }) => ($variant === 'negative' ? negativeBg : positiveBg)};
  color: ${({ $variant }) => ($variant === 'negative' ? colors.Red : colors.LightBlue)};
`;

export const BadgeDot = styled.span`
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: currentcolor;
  display: inline-block;
  flex-shrink: 0;
`;

const primaryLight = colors.brand.primary.lighter;

export const BtnPrimary = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 7px;
  background: ${colors.brand.principal};
  color: ${colors.White};
  border: none;
  border-radius: 8px;
  padding: 8px 12px;
  height: 30px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  flex-shrink: 0;
  align-self: flex-start;
  &:hover:not(:disabled) { background: ${colors.brand.principalHover};
    color: ${colors.White};
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const BtnOutline = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 7px;
  background: transparent;
  color: ${colors.brand.principal};
  border: 1px solid ${colors.Blue050};
  border-radius: 8px;
  padding: 6px 12px;
  height: 28px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  flex-shrink: 0;
  align-self: flex-start;
  &:hover { background: ${primaryLight}; }
`;

export const BtnDanger = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 7px;
  background: transparent;
  color: ${colors.Red};
  border: 1px solid ${colors.Red};
  border-radius: 8px;
  padding: 6px 12px;
  height: 28px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  &:hover { background: #fff5f5; }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
